(function () {
  var CONFIG_EL = document.getElementById('copa-brinde-config');
  if (!CONFIG_EL) return;

  var config;
  try {
    config = JSON.parse(CONFIG_EL.textContent);
  } catch (e) {
    return;
  }

  if (!config.enabled || !config.variantId) return;

  var syncing = false;
  var PROPERTY = config.propertyKey || '_copa_brinde';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return 'R$ ' + value;
  }

  function isBrindeItem(item) {
    if (!item) return false;
    if (item.properties && item.properties[PROPERTY]) return true;
    if (config.productHandle && item.handle === config.productHandle) return true;
    return String(item.variant_id) === String(config.variantId);
  }

  function cartSubtotalExcludingBrinde(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (!isBrindeItem(item)) {
        total += item.final_line_price || item.line_price || 0;
      }
    });
    return total;
  }

  function findBrindeLine(cart) {
    return (cart.items || []).find(function (item, index) {
      item._line = index + 1;
      return isBrindeItem(item);
    });
  }

  function updateProgressUI(cart) {
    var subtotal = cartSubtotalExcludingBrinde(cart);
    var min = config.minCents || 45000;
    var remaining = Math.max(0, min - subtotal);
    var pct = Math.min(100, Math.round((subtotal / min) * 100));
    var unlocked = subtotal >= min;
    var brindeLine = findBrindeLine(cart);

    document.querySelectorAll('.js-copa-brinde').forEach(function (el) {
      el.classList.toggle('copa-brinde--unlocked', unlocked);
      el.classList.toggle('copa-brinde--in-cart', !!brindeLine);
      el.dataset.subtotal = String(subtotal);

      var bar = el.querySelector('[data-copa-brinde-progress]');
      if (bar) bar.style.width = pct + '%';

      var text = el.querySelector('[data-copa-brinde-text]');
      if (!text) return;

      if (unlocked) {
        text.textContent = brindeLine
          ? 'Brinde PATCH COPA Copa 2026 adicionado ao seu pedido!'
          : 'Parabéns! Você ganhou o Patch Cord personalizado Copa 2026!';
      } else {
        text.textContent =
          'Faltam ' +
          formatMoney(remaining) +
          ' para ganhar Patch Cord Copa 2026 personalizado';
      }
    });
  }

  function fetchCart() {
    return fetch((window.Shopify && Shopify.routes.root) || '/' + 'cart.js', {
      credentials: 'same-origin',
    }).then(function (r) {
      return r.json();
    });
  }

  function addBrinde() {
    return fetch(((window.Shopify && Shopify.routes.root) || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [
          {
            id: config.variantId,
            quantity: 1,
            properties: {
              [PROPERTY]: 'true',
              Brinde: 'Patch Cord Copa 2026 personalizado',
            },
          },
        ],
      }),
    });
  }

  function removeBrinde(line) {
    return fetch(((window.Shopify && Shopify.routes.root) || '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: 0 }),
    });
  }

  function syncBrinde() {
    if (!config.autoAdd || syncing) return Promise.resolve();
    syncing = true;

    return fetchCart()
      .then(function (cart) {
        var subtotal = cartSubtotalExcludingBrinde(cart);
        var brindeLine = findBrindeLine(cart);
        var min = config.minCents || 45000;

        if (subtotal >= min && !brindeLine) {
          return addBrinde().then(fetchCart);
        }
        if (subtotal < min && brindeLine) {
          return removeBrinde(brindeLine._line).then(fetchCart);
        }
        return cart;
      })
      .then(function (cart) {
        updateProgressUI(cart);
        syncing = false;
        return cart;
      })
      .catch(function () {
        syncing = false;
      });
  }

  function onCartChange() {
    fetchCart().then(function (cart) {
      updateProgressUI(cart);
      return syncBrinde();
    });
  }

  document.addEventListener('DOMContentLoaded', onCartChange);
  document.body.addEventListener('ajax:addToCart', onCartChange);
  document.body.addEventListener('ajax:updateCart', onCartChange);
  document.body.addEventListener('ajax:deleteCart', onCartChange);
  document.body.addEventListener('update:miniCart', onCartChange);
})();
